/* istanbul ignore file */
import { UpdatePageLayout } from 'framework/ui/layout';
import { UpdateForm, FormFieldsData } from 'framework/form';
import UpdateAccountBreadcrumbs from 'domain/sales/account/createupdate/Update/Breadcrumbs';
import AccountForm from 'domain/sales/account/createupdate/AccountForm';
import { useAccountId } from 'domain/sales/account/accountRouting';
import { useAccountUrl } from 'domain/shared/account';
import { useMessageService, WarningMessage } from 'framework/ui/Message';
import useAccountManagementService from '../../useAccountManagementService';

const UpdateAccount = () => {
  const { update, getById, getValidationSchema, getOriginalName, patchLitigationHold } = useAccountManagementService();
  const { getSingleEntityUrl } = useAccountUrl();
  const id = useAccountId();
  const { addMessage } = useMessageService();

  const getDataMethod = async (accountId: StringOrNumber) => {
    const data = await getById(accountId);
    const originalName = await getOriginalName(accountId);

    const base = {
      ...data,
      accountName: data.hasCodeName ? data.accountName : '',
      originalName: originalName[accountId].realAccountName,
    };
    return base;
  };

  const submitFormFunc = async (accountId: StringOrNumber, values: FormFieldsData) => {
    const response = await update(accountId, values);

    const originalHold = values.originalIsOnLitigationHold as boolean | undefined;
    const currentHold = values.isOnLitigationHold as boolean | undefined;
    const originalReason = values.originalLitigationHoldReason as string | undefined;
    const currentReason = values.litigationHoldReason as string | undefined;
    const accountAlias = values.accountId as string | undefined;

    if (
      accountAlias &&
      originalHold !== undefined &&
      currentHold !== undefined &&
      (Boolean(originalHold) !== Boolean(currentHold) || (originalReason ?? '') !== (currentReason ?? ''))
    ) {
      try {
        await patchLitigationHold(accountAlias, currentHold, currentReason);
      } catch {
        addMessage(
          new WarningMessage(
            'The account was saved, but the litigation hold settings could not be updated. You may try again from the account page.',
          ),
        );
      }
    }

    return response;
  };

  return (
    <UpdateForm
      submitFormFunc={submitFormFunc}
      getDataFunc={getDataMethod}
      getValidationSchemaFunc={getValidationSchema}
      afterSubmit={{
        redirect: getSingleEntityUrl(id),
        message: 'You are awesome! The Account has been successfully saved.',
      }}
    >
      <UpdatePageLayout title="Edit: Account" breadcrumbs={<UpdateAccountBreadcrumbs />}>
        <AccountForm />
      </UpdatePageLayout>
    </UpdateForm>
  );
};

export default UpdateAccount;
